const actions = {
  LIST_TRANSACTIONS_REQUEST: 'LIST_TRANSACTIONS_REQUEST',
  LIST_TRANSACTIONS_SUCCESS: 'LIST_TRANSACTIONS_SUCCESS',
  LIST_TRANSACTIONS_ERROR: 'LIST_TRANSACTIONS_ERROR',
  LIST_BILLS_REQUEST: 'LIST_BILLS_REQUEST',
  LIST_BILLS_SUCCESS: 'LIST_BILLS_SUCCESS',
  LIST_BILLS_ERROR: 'LIST_BILLS_ERROR',
  listTransactions: (token = false, environment) => ({
    type: actions.LIST_TRANSACTIONS_REQUEST,
    token,
    environment
  }),
  listBills: (token = false) => ({
    type: actions.LIST_BILLS_REQUEST,
    token
  })

 
};
export default actions;
